import { makeAutoObservable } from 'mobx';
import { validatePreserveProfit } from './validatePreserveProfit';

export class PreserveProfitData {
  amount = 0;
  activationProfitAmount = 0;

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }
  resetToDefaults = () => {
    this.amount = 0;
    this.activationProfitAmount = 0;
  };

  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };

  validate = () => {
    const result = validatePreserveProfit(this);
    return result;
  };
  returnJson = () => {
    return {
      amount: this.amount,
      activationProfitAmount: this.activationProfitAmount,
    };
  };
  //specific methods
  setAmount = (number) => {
    this.amount = number;
  };
  setActivationProfitAmount = (number) => {
    this.activationProfitAmount = number;
  };
}
